import { default as focusDecorator } from 'final-form-focus';
import { getIn } from 'final-form';

const findInput = (inputs, errors) =>
    inputs.find((input) => {
        const name = input.name || input.id;
        return name && getIn(errors, name);
    });

export const focusOnError = focusDecorator(null, findInput);